/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetSupplierName
 */
export interface SetSupplierName {
    /**
     * 
     * @type {string}
     * @memberof SetSupplierName
     */
    clientRef?: string;
    /**
     * 
     * @type {string}
     * @memberof SetSupplierName
     */
    full?: string;
    /**
     * 
     * @type {string}
     * @memberof SetSupplierName
     */
    _short?: string;
}

/**
 * Check if a given object implements the SetSupplierName interface.
 */
export function instanceOfSetSupplierName(value: object): value is SetSupplierName {
    return true;
}

export function SetSupplierNameFromJSON(json: any): SetSupplierName {
    return SetSupplierNameFromJSONTyped(json, false);
}

export function SetSupplierNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetSupplierName {
    if (json == null) {
        return json;
    }
    return {
        
        'clientRef': json['clientRef'] == null ? undefined : json['clientRef'],
        'full': json['full'] == null ? undefined : json['full'],
        '_short': json['short'] == null ? undefined : json['short'],
    };
}

export function SetSupplierNameToJSON(value?: SetSupplierName | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientRef': value['clientRef'],
        'full': value['full'],
        'short': value['_short'],
    };
}

